import { useParams } from 'react-router'

/**
 * Typed param hooks — one per dynamic route segment.
 * Centralizes the `as { param: string }` cast so callsites don't need it.
 * The route guarantees these params exist when the component renders.
 */
export const useTableParams = () => useParams() as { table_id: string }
export const useFormParams = () => useParams() as { form_id: string }
export const useChartParams = () => useParams() as { chart_id: string }
export const useRecordParams = () => useParams() as { record_id: string }
export const useDocumentParams = () => useParams() as { document_id: string }
export const useWorkspaceParams = () => useParams() as { workspace_id: string }
export const useWorkflowParams = () => useParams() as { workflow_id: string }
export const usePivotTableParams = () => useParams() as { pivot_table_id: string }
export const useChatParams = () => useParams() as { chat_id: string }
export const useRoleParams = () => useParams() as { role_id: string }
